import Logo from "./Logo";
import { scrollToId } from "./Header";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-slate-900 text-slate-400 border-t border-slate-800">
            <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-14">
                <div className="grid md:grid-cols-3 gap-10">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <Logo className="w-9 h-9" />
                            <span className="font-display font-bold text-lg text-white">
                                Aus<span className="text-cyan-400">Research</span>
                            </span>
                        </div>
                        <p className="text-sm leading-relaxed">
                            Australian research-peptide supply house serving verified institutions with
                            batch-documented reference compounds.
                        </p>
                    </div>
                    <div>
                        <div className="font-jbm text-[10px] uppercase tracking-widest text-slate-500 mb-4">Navigate</div>
                        <div className="flex flex-col gap-2.5">
                            {[
                                ["Catalog", "#catalog"],
                                ["Quality", "#quality"],
                                ["About", "#about"],
                                ["Compliance", "#compliance"],
                                ["Reviews", "#reviews"],
                                ["B2B Enquiry", "#enquiry"],
                            ].map(([label, href]) => (
                                <button
                                    key={href}
                                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                                    onClick={() => scrollToId(href)}
                                    className="text-left text-sm hover:text-cyan-400 transition-colors duration-300 w-fit"
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div>
                        <div className="font-jbm text-[10px] uppercase tracking-widest text-slate-500 mb-4">Legal</div>
                        <p className="text-xs leading-relaxed">
                            All products listed are for laboratory research use only and are not for human or
                            veterinary use. Nothing on this site constitutes an offer of sale, therapeutic claim or
                            medical advice. Materials are not listed on the Australian Register of Therapeutic Goods.
                        </p>
                    </div>
                </div>
                <div className="mt-12 pt-6 border-t border-slate-800 flex flex-wrap justify-between gap-3 font-jbm text-[11px] tracking-wide text-slate-500">
                    <span>© {new Date().getFullYear()} AusResearch. All rights reserved.</span>
                    <span>RESEARCH USE ONLY · NOT FOR HUMAN CONSUMPTION</span>
                </div>
            </div>
        </footer>
    );
}
